import apiClient from '../apiClient'

export const fetchOutlets = async () => {
  const { data } = await apiClient.get('/api/outlets')
  return data
}
